import morphdom from "morphdom"
import { buildOptions } from "web-ui/morphdom/build-options"

function morphdomRender({ detail }) {
  detail.render = (fromElement, toElement) => {
    const options = buildOptions({
      childrenOnly: true
    })

    morphdom(fromElement, toElement, options)
  }
}

export function activate() {
  addEventListener("turbo:before-frame-render", morphdomRender)
}
